import axios from 'axios';

const DEFAULT_DOMAIN = '';
const API_PREFIX = 'api/fe/marketplace';


const composeMarkersQueryStr = (queryStr, variation) => {
  return [
    queryStr,
    variation
  ]
    .filter(Boolean)
    .join('&');

};

// TODO: support filters as query
export function getUnitPricesRequest(areaId, options = {}) {
  const { domain = DEFAULT_DOMAIN, queryStr = '' } = options;
  const path = `${domain}/${API_PREFIX}/unit-prices/${areaId}?${queryStr}`;

  return axios.get(path);
}

export function getRentableUnitRequest(rentableId, lang = '', options = {}) {
  const params = { lang };
  const { cookie, domain = DEFAULT_DOMAIN } = options;
  const path = `${domain}/${API_PREFIX}/rentable-unit/${rentableId}`;
  const headers = {};

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.get(path, { headers, params });
}

export function getSimilarRentableUnitsRequest(
  rentableId,
  lang = '',
  options = {}
) {
  const { cookie, domain = DEFAULT_DOMAIN, query = {} } = options;
  const params = { lang, ...query };
  const path = `${domain}/${API_PREFIX}/similars/${rentableId}`;
  const headers = {};

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.get(path, { headers, params });
}

export function getMarkersRequest(areaId, options = {}) {
  const {
    cookie,
    domain = DEFAULT_DOMAIN,
    queryStr = '',
    variation
  } = options;
  const composedQueryStr = composeMarkersQueryStr(queryStr, variation);
  const path = `${domain}/${API_PREFIX}/markers/${areaId}?${composedQueryStr}`;
  const headers = {};

  if (cookie) {
    headers.cookie = cookie;
  }

  return axios.get(path, { headers });
}

export default {
  getUnitPricesRequest,
  getRentableUnitRequest,
  getSimilarRentableUnitsRequest,
  getMarkersRequest
};
